// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingTitle_wrapper__3OGQ0","loading":"LoadingTitle_loading__2jwEI","load":"LoadingTitle_load__TBPgI"};